import { useToast } from 'primevue/usetoast'

export function useAppToast() {
  const toast = useToast()

  function success(detail, summary = 'Успешно') {
    toast.add({
      severity: 'success',
      summary,
      detail,
      life: 3000
    })
  }

  function error(detail, summary = 'Ошибка') {
    toast.add({
      severity: 'error',
      summary,
      detail,
      life: 4000
    })
  }

  function info(detail, summary = 'Информация') {
    toast.add({
      severity: 'info',
      summary,
      detail,
      life: 3000
    })
  }

  function warn(detail, summary = 'Внимание') {
    toast.add({
      severity: 'warn',
      summary,
      detail,
      life: 3500
    })
  }

  return {
    success,
    error,
    info,
    warn
  }
}